jQuery(document).ready(function ($) {

    let forumCategories = [];
    let tipCategories = [];
    let isVerifiedUser = false;
    let ageVerification = false;

    // ReCAPTCHA validation functions
    function validateRecaptcha($form) {
        const $recaptcha = $form.find('.g-recaptcha');
        if ($recaptcha.length === 0) {
            return true; // No reCAPTCHA on this form
        }
        
        // Check if the reCAPTCHA response input exists and has a value
        const responseInput = $form.find('textarea[name="g-recaptcha-response"]');
        if (responseInput.length > 0 && responseInput.val().length > 0) {
            return true;
        }
        
        // Fallback: try to get response using grecaptcha API
        if (typeof grecaptcha !== 'undefined') {
            const response = grecaptcha.getResponse();
            if (response && response.length > 0) {
                return true;
            }
        }
        
        return false;
    }

    function showRecaptchaError($form) {
        let $errorDiv = $form.find('.recaptcha-error');
        
        if ($errorDiv.length === 0) {
            $errorDiv = $('<div class="recaptcha-error" style="color: #dc3545; margin-top: 10px; font-size: 14px;">Please complete the reCAPTCHA verification.</div>');
            $form.find('.g-recaptcha').after($errorDiv);
        }
        
        $errorDiv.show();
        
        // Scroll to reCAPTCHA
        $('html, body').animate({
            scrollTop: $form.find('.g-recaptcha').offset().top - 100
        }, 500);
    }

    function hideRecaptchaError($form) {
        $form.find('.recaptcha-error').hide();
    }

    function resetRecaptcha($form) {
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.reset();
        }
        hideRecaptchaError($form);
    }

    // Initialize reCAPTCHA handlers
    function initRecaptchaHandlers() {
        $('form').each(function() {
            const $form = $(this);
            const $recaptcha = $form.find('.g-recaptcha');
            
            if ($recaptcha.length > 0) {
                // Handle form reset
                $form.find('input[type="reset"], button[type="reset"]').on('click', function() {
                    setTimeout(function() {
                        resetRecaptcha($form);
                    }, 100);
                });
                
                // Handle clear form actions
                $form.find('.clear-all-data-button').on('click', function() {
                    setTimeout(function() {
                        resetRecaptcha($form);
                    }, 100);
                });
            }
        });
    }

    // ReCAPTCHA callback functions
    window.onRecaptchaSuccess = function(response) {
        $('form').each(function() {
            const $form = $(this);
            const $recaptcha = $form.find('.g-recaptcha');
            if ($recaptcha.length > 0) {
                hideRecaptchaError($form);
            }
        });
    };

    window.onRecaptchaExpired = function() {
        $('form').each(function() {
            const $form = $(this);
            const $recaptcha = $form.find('.g-recaptcha');
            if ($recaptcha.length > 0) {
                showRecaptchaError($form);
            }
        });
    };

    // Initialize reCAPTCHA when ready
    if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
        grecaptcha.ready(function() {
            initRecaptchaHandlers();
        });
    } else {
        // Fallback if grecaptcha.ready is not available
        setTimeout(function() {
            initRecaptchaHandlers();
        }, 1000);
    }

    // General form submission handler for all forms with reCAPTCHA
    $(document).on('submit', 'form', function(e) {
        const $form = $(this);
        const $recaptcha = $form.find('.g-recaptcha');
        
        if ($recaptcha.length > 0) {
            if (!validateRecaptcha($form)) {
                e.preventDefault();
                e.stopPropagation();
                showRecaptchaError($form);
                return false;
            } else {
                hideRecaptchaError($form);
            }
        }
    });

    // Utility function for AJAX form submissions
    window.validateFormRecaptcha = function(formSelector) {
        const $form = $(formSelector);
        if ($form.length === 0) return true;
        
        const $recaptcha = $form.find('.g-recaptcha');
        if ($recaptcha.length === 0) return true;
        
        if (!validateRecaptcha($form)) {
            showRecaptchaError($form);
            return false;
        } else {
            hideRecaptchaError($form);
            return true;
        }
    };

    $.ajax({
        url: script_object.ajax_url,
        type: "POST",
        data: {
            action: "isEmailVerified",
        },
        success: function (response) {
            isVerifiedUser = response.data;
        },
    })

    $.ajax({
        url: script_object.ajax_url,
        type: "POST",
        data: {
            action: "ageVerification",
        },
        success: function (response) {
            ageVerification = response.data;
        },
    })
    
    const CPT_PLACEHOLDER_TIPS = 'Velg Sport';
    const CPT_PLACEHOLDER_FORUM = 'Velg Kategori';

    function syncCptCategoryDropdown() {
        const isTips = $('input[name="cpType"]:checked').val() === '1';
        if (isTips) {
            if (tipCategories && tipCategories.length) {
                showCategories(tipCategories, CPT_PLACEHOLDER_TIPS);
            }
        } else if (forumCategories && forumCategories.length) {
            showCategories(forumCategories, CPT_PLACEHOLDER_FORUM);
        }
    }

    // Use the generic function to fetch forum categories
    fetchCategories(
        script_object.ajax_url,
        { action: 'forum_topic', function: 'get_forum_categories' },
        function(response) {
            forumCategories = response;
            syncCptCategoryDropdown();
        },
        function(xhr, status, error) {
            console.error("Failed to fetch forum categories:", error);
        }
    );

    // Use the generic function to fetch tip categories
    fetchCategories(
        script_object.ajax_url,
        { action: 'forum_topic', function: 'get_tips_categories' },
        function(response) {
            tipCategories = response;
            syncCptCategoryDropdown();
        },
        function(xhr, status, error) {
            console.error("Failed to fetch tip categories:", error);
        }
    );
    
    $('#title-create-post').keyup(function () {
        let length = $(this).val().length;
        $(this).siblings("p").find('span').html(length);
    });

    $('.create-post-modal .icon-close').click(function () {
        $(this).parents('.create-post-modal').addClass('d-none');
        $('body').removeClass('disable-scroll');
        
        // Reset reCAPTCHA when modal is closed
        if (typeof grecaptcha !== 'undefined') {
            try {
                grecaptcha.reset();
            } catch (error) {
                console.log('reCAPTCHA reset error:', error);
            }
        }
    })

    $('.create-post-button button').click(function () {
        $('.create-post-modal').removeClass('d-none');
        $('.create-post-modal .errors').html('');
        $('body').addClass('disable-scroll');
    })

    $(document).mouseup(function (e) {
        let container = $(".create-post-modal");
        if (container.length && !container.hasClass('d-none')) {
            container = container.find('form');

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                let header = $("header");
                let modul_page = $(".module-page");
                let footer = $("footer");
                if (header.is(e.target) || header.has(e.target).length > 0 ||
                    modul_page.is(e.target) || modul_page.has(e.target).length > 0 ||
                    footer.is(e.target) || footer.has(e.target).length > 0) {
                    $('.create-post-modal').addClass('d-none');
                    $('.create-post-modal .errors').html('');
                    $('body').removeClass('disable-scroll');
                    
                    // Reset reCAPTCHA when modal is closed
                    if (typeof grecaptcha !== 'undefined') {
                        try {
                            grecaptcha.reset();
                        } catch (error) {
                            console.log('reCAPTCHA reset error:', error);
                        }
                    }
                }
            }
        }
    });

    if ($('input#legal_age').prop('checked')) {
        $('#age-verification').removeClass('hidden');
    }

    $('input#legal_age').change(function() {
        if ($(this).prop('checked')) {
            $('#age-verification').removeClass('hidden');
        } else {
            $('#age-verification').addClass('hidden');
        }
    });

    $('#age-verification').click(function(e) {
        e.preventDefault(); // Prevent the default form submission (page reload)

        // Get the current state of the checkbox
        var legalAgeChecked = $('#legal_age').prop('checked');

        // Perform the AJAX request to save the legal age status
        $.ajax({
            url: script_object.ajax_url, // Use the script_object.ajax_url for the AJAX URL
            type: "POST",
            data: {
                action: "ageVerification", // Action hook to be used in PHP to process this request
                legal_age_checked: legalAgeChecked // Send the checkbox state (true/false)
            },
            success: function(response) {
                if (response.success) {
                    $('#age-verification').addClass('hidden');
                    $('input#legal_age').addClass('hidden');
                    $('.legal-age').text('Du har bekreftet alderen din.');
                    $('.legal-age').text('Du har bekreftet alderen din.');
                    $('.legal-age').addClass('text-success')
                } else {
                    alert('Det oppsto en feil under lagring av aldersbekreftelsen din.');
                    alert('Det oppsto en feil under lagring av aldersbekreftelsen din.');
                }
            },
            error: function() {
                alert('Det var et problem med forespørselen.');
                alert('Det var et problem med forespørselen.');
            }
        });
    });

    $(".create-post-modal form").on('submit', function (e) {
        let errors = [];

        // Add reCAPTCHA validation
        if (!validateRecaptcha($(this))) {
            errors.push('Please complete the reCAPTCHA verification.');
            showRecaptchaError($(this));
            e.preventDefault();
            return false;
        } else {
            hideRecaptchaError($(this));
        }

        if(!ageVerification) {
            if (!$(this).find('input#legal_age').prop('checked')) {
                errors.push('Bekreft at du er over 18.');
            }
        }

        if( isVerifiedUser ) {

            if ($(this).find('input#title-create-post').val().length === 0) {
                errors.push('Tittel er obligatorisk.');
            }

            if ($(this).find('select[name=cpt_category]').val() === null) {
                errors.push('Kategori er obligatorisk.');
            }

            if ($(this).find('#content-post-wysiwyg').val() === '') {
                errors.push('Beskrivelse er obligatorisk.');
            }

        

            if (!$(this).find('.tips-parents').hasClass('d-none')) {
                if ($("input[name=second_cpType]:checked").val() == 2) {

                    if ($(this).find('#post_odds').val() == '') {
                        errors.push('Trykk "Hent kamp-data" for å velge kamp');
                    }

                    if ($(this).find('#tip-outcome-create-post-auto').val() === '')
                        errors.push('Tip outcome is required.');

                    if ($(this).find('#odds-create-post-auto').val() === '')
                        errors.push('Odds is required.');

                    if ($(this).find('#stake-create-post-auto').val() === '')
                        errors.push('Stake is required.');

                    if ($(this).find('#company-create-post option:selected').val() === '')
                        errors.push('Bookmaker er obligatorisk.');
                }
            }


            if (!$(this).find('.tips-content').hasClass('d-none')) {

                if ($(this).find('#league-create-post').val() === '')
                    errors.push('Liga er obligatorisk.');

                if ($(this).find('#match-athletes-create-post').val() === '')
                    errors.push('Kamp/utøver er obligatorisk.');

                if ($(this).find('#tip-outcome-create-post').val() === '')
                    errors.push('Tips/utfall er obligatorisk.');

                if ($(this).find('#game-stop-create-post').val() === '')
                    errors.push('Dato er obligatorisk.');

                if ($(this).find('#odds-create-post').val() === '')
                    errors.push('Odds er obligatorisk.');

                if ($(this).find('#stake-create-post').val() === '')
                    errors.push('Innsats er obligatorisk.');

                if ($(this).find('#company-create-post option:selected').val() === '') {
                    errors.push('Bookmaker er obligatorisk.');
                }
            }
        } else {
            $(this).find('.email-verified-error').addClass('d-none');
            errors.push(`<div class="verification-js-error"><p class="verification-text">Du har ikke lov til å lage et innlegg før du har bekreftet kontoen din.</p> <button class="send-verification-email">Send lenken på nytt.</button></div>`);
        }

        if (errors.length > 0) {
            let errorsDiv = $(this).find('.errors');
            errorsDiv.html('');
            errors.map(item => {
                errorsDiv.append('<p>' + item + '</p>');
            });
            $(this).find('button.add-disable').removeClass('disabled').css('pointer-events', 'auto');
            $(this).find('button.add-disable').css('background-color', '#32CD95');
            e.preventDefault();
            return false;
        }
        
        $(this).find('button.add-disable').addClass('disabled').css('pointer-events', 'none');
        $(this).find('button.add-disable').css('background-color', '#9ADFC1');

        return true;
    });

    let page = 0;
    let forum_number_topics = parseInt($('#forum_number_topics').text());
    let post_per_page = parseInt($('#load-forum-more-posts').text());
    let offset = 0; 

    function load_more_posts(e) {
        $.ajax({
            method: 'POST',
            url: script_object.ajax_url,
            type: 'JSON',
            data: {
                page: e <= 0 ? 0 : ++page,
                taxonomy: $('#taxonomy_type').text(),
                terms: $('#select_taxonomy').text(),
                posts_per_page: e <= 0 ? forum_number_topics : post_per_page,
                offset:  e <= 0 ? 0 : offset, 
                number_topics: forum_number_topics,
                action: 'forum_topic'
            },
            success: function (response) {
                if (e <= 0) {
                    $('.card-out-ajax').css('display', 'none');
                    offset = forum_number_topics; 
                }
                $('.load_more_posts').removeClass('active');
                if (response.indexOf('last_post_loaded_forum') > -1) {
                    $('.load_more_posts').hide();
                }
                $(".forum-topics-card").append(response);
                if( e > 0 ){
                    offset += post_per_page;
                }
            },
        });
    }

    $(document).on('scroll', function (e) {
        if (page <= 0) {
            page = 2;
            load_more_posts(0);
        }
    });
    $('.load_more_posts').on('click', function (e) {
        $(this).addClass('active');
        load_more_posts(page);
    });

    function fetchCategories(url, data, onSuccess, onError) {
        $.ajax({
            dataType: 'json', // Note the correct case
            url: url,
            type: 'GET',
            data: data,
            success: onSuccess,
            error: onError || function(xhr, status, error) {
                console.error("AJAX error:", error);
            },
        });
    }

    function showCategories(categories, placeholderText) {
        // Only update the create-post dropdown — never the edit modal
        // (both use name="cpt_category"; edit options are server-rendered with selected)
        const $select = $('.create-post-modal select.cpt-category[name="cpt_category"]');
        if (!$select.length) {
            return;
        }
        $select.find('option').not(':first').remove();
        if (placeholderText) {
            $select.find('option:first').text(placeholderText);
        }
        categories.forEach(category => {
            $select.append(`<option value="${category.term_id}">${category.name}</option>`)
        });
    }

    $(".cpt-category").change(function () {

        var selectedCategory = $(".cpt-category")
          .children("option:selected")
          .val();
        let tips_content = $(".tips-content");
        let manual_statistic = $(".manual-statistic");
        let tips_parents = $(".tips-parents");
        if (selectedCategory == 13) {

          tips_parents.removeClass("d-none");

          $(".tips-parents label").on("click", function () {

            $(".tips-parents label").removeClass("selected");

            let input = $(this).find("input");
            let tips_contents = $(".tips-contents");
            let bookmakers = $(".tips-bookmakers");
            let betting_statistic = $(".statistic-input");
            input.attr("checked", true);
            $(this).addClass("selected");

            if (input.val() === "2") {

              tips_contents.removeClass("d-none");
              manual_statistic.removeClass("d-none");
              tips_content.addClass("d-none");
              bookmakers.removeClass("d-none");
              betting_statistic.addClass("d-none");
            } else if (input.val() === "3") {
                
              tips_content.removeClass("d-none");
              manual_statistic.addClass("d-none");
              betting_statistic.removeClass("d-none");
              tips_contents.addClass("d-none");
              $(".sports-data-fields").addClass("d-none");
            }
          });
        } else if (
          tipCategories &&
          document.querySelector('input[name="cpType"]')
        ) {
          tips_parents.addClass("d-none");
        }
      });

    $('.tips-parent label').on('click', function () {
        $('.tips-parent label').removeClass('selected');
        let input = $(this).find('input');
        let tips_content = $('.tips-content');
        let league_parent = $('.league-parent');
        let betting_statistic = $('.statistic-input');
        input.attr('checked', true);
        $(this).addClass('selected');
        if (input.val() === '1') {
            showCategories(tipCategories, CPT_PLACEHOLDER_TIPS);
            tips_content.removeClass('d-none');
            betting_statistic.removeClass('d-none');
            league_parent.removeClass('d-none');
        } else {
            $('.tips-parents').addClass('d-none');
            tips_content.addClass('d-none');
            league_parent.addClass('d-none');
            betting_statistic.addClass('d-none');
            showCategories(forumCategories, CPT_PLACEHOLDER_FORUM);
        }
    });


    $('.league-parent label').on('click', function () {
        $('.league-parent label').removeClass('selected');
        let input = $(this).find('input');
        input.attr('checked', true);
        $(this).addClass('selected');
    });

    $('.statistic-input label').on('click', function () {
        $('.statistic-input label').removeClass('selected');
        let input = $(this).find('input');
        input.attr('checked', true);
        $(this).addClass('selected');
    });
   
    $('#btn-login-modal').click(function () {
        $('#login-register-modal').removeClass('show-register d-none');
        $('body').addClass('modal-active disable-scroll');
    });

    $('#btn-login-modal-header').click(function () {
        $('#login-register-modal').removeClass('show-register d-none');
        $('body').addClass('modal-active disable-scroll');
    });

    $(document).on('click', '.follow-user-post', function (e) {
        var authorID = $(this).attr('data-authorID');
        var userID = $(this).attr('data-userID');

        $(this).parent().remove();

        $.ajax({
            datatype: 'json',
            url: script_object.ajax_url,
            type: 'POST',
            data: {
                action: 'forum_topic',
                function: 'follow_user',
                userID: userID,
                authorID: authorID,
            },
            success: (data) => {

            }
        });

    });

    $(document).on('click', '.nots-follow', function (e) {
        var authorID = $(this).attr('data-authorID');
        var userID = $(this).attr('data-userID');
        $.ajax({
            method: 'POST',
            url: script_object.ajax_url,
            type: 'JSON',
            data: {
                action: 'forum_topic',
                function: 'follow_user',
                userID: userID,
                authorID: authorID,
            },
            success: function (response) {
            },
        });
        $(this).addClass("d-none");
    });

    $('.follow-user-loggedOut').click(function () {
        $('#login-register-modal').removeClass('show-register d-none');
        $('body').addClass('modal-active disable-scroll');
    });
});